const PlusIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1201_41248" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
        <rect y="0.500122" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1201_41248)">
        <path
          d="M11 13.5001H5V11.5001H11V5.50012H13V11.5001H19V13.5001H13V19.5001H11V13.5001Z"
          fill="#6E6E6E"
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
